import Phaser from 'phaser';
import Boot from './view/boot.js';
import Preload from './view/preload.js';
import Login from './view/login.js';
import RegisterChoose from './view/register-choose.js';
import SignUp from './view/sign-up.js';
import SignUpOrg from './view/sign-up-org.js';
import ResetPassword from './view/reset-password.js';
import SendEmail from './view/send-email.js';
import Verify2FA from './view/verify-2fa.js';
// import Language from "./view/language.js";
import Menu from './view/menu.js';
import Rules from './view/rules.js';
import CategorySelection from './view/category-selection-searcher.js';
import Testimonial from './view/testimonial.js';
import Time from './view/select-time.js';
import Intro from './view/intro.js';
import Board from './view/board.js';
import BoardViewOnly from './view/boardViewOnly.js';
import EndScreen from './view/end-screen.js';
import EndScreenClient from './view/end-screen-client.js';
import LicenseExpiredOverlay from './view/license.js';

const config = {
	type: Phaser.CANVAS,
	width: 1500,
	height: 929,
	scene: [
		Boot,
		Preload,
		Login,
		RegisterChoose,
		SignUp,
		SignUpOrg,
		ResetPassword,
		SendEmail,
		Verify2FA,
		LicenseExpiredOverlay,
		// Language,
		Menu,
		Time,
		CategorySelection,
		Rules,
		Testimonial,
		Intro,
		Board,
		BoardViewOnly,
		EndScreen,
		EndScreenClient,
	],
	scale: {
		mode: Phaser.Scale.FIT,
		autoCenter: Phaser.Scale.CENTER_BOTH,
	},
	parent: 'app',
	dom: {
		createContainer: !0,
	},
};

export default new Phaser.Game(config);
